import { ArrowRightOutlined } from "@ant-design/icons";
import React from "react";
import Skeleton from "react-loading-skeleton";


const GaslessFooterTile = ({ iconClass, link, title ,isLoading}) => (
    <article className="tile tile-small">
        <div className="tile-header">
            <i className={iconClass} />
            <span>
        <u>{title}</u>
      </span>
        </div>
        <a href={link} target="_blank">
      <span className="icon-button">
        <ArrowRightOutlined />
      </span>
        </a>
    </article>
);

const GaslessFooterDetails = ({isLoading}) => {
    const tiles = [
        {
            iconClass: "ph-lightning-light",
            link: "your_link_1",
            title: "Gasless Transactions Integration Guide",
        },
        {
            iconClass: "ph-fire-simple-light",
            link: "your_link_2",
            title: "Gasless API Docs",
        },
        {
            iconClass: "ph-file-light",
            link: "your_link_3",
            title: "Gasless SDK Docs",
        },
        {
            iconClass: "ph-file-light",
            link: "/advanced/ai-assistant",
            title: "Contact to Enable Gasless on your Protocol",
        },
    ];

    return (
        <div className="gasless-footer-container">
            <div className="container-text">
                <div className="text marginTop10px marginBtm10">Need Help ?</div>
            </div>
            <div className="gasless-footer-container">
                <div className="tiles">
                    {tiles.map((tile, index) => (<>
                        {isLoading?(<Skeleton height={100} width={310} style={{marginTop:'30px'}} baseColor="#262626" highlightColor="#404040" ></Skeleton>):(  
                        <GaslessFooterTile
                            key={index}
                            iconClass={tile.iconClass}
                            link={tile.link}
                            title={tile.title}
                        />
                        )}
                   </> ))}
                </div>
            </div>
        </div>
    );
};

export default GaslessFooterDetails;
